module.exports = __webpack_public_path__ + "static/media/12.3f032d8d.jpg";